import React, { Fragment } from 'react'
import { find, isBlank, merge } from 'lodash'
import Select from 'UI/Select'

const defaultFilters = {
  currentTab: 'SQL',
  licensableSoftware: 'All',
  licensableSoftwareGroups: 'All',
  currentView: 'operating_systems',
  customers: 'All',
  clusters: 'All',
  locations: 'All',
  functions: 'All',
  ownerships: 'All',
  powerState: 'All',
  editions: 'All',
  resources: 'All',
  showSummary: true,
  groupByField: 'Cluster',
  machine_type_sources: 'All',
  platformTypes: 'All',
  operating_systems: 'All',
  vendors: 'All',
  regions: 'All',
  applicationEditions: 'All',
  customersStatus: 'All'
}

const defaultApplicationFilters = {
  ...defaultFilters,
  currentView: 'applications',
  currentTab: 'SQL',
  groupByField: 'Customer',
}

const defaultOperatingSystemFilters = {
  ...defaultFilters,
  currentTab: 'ms-operatingSystems',
  currentView: 'operating_systems',
  groupByField: 'Customer',
}

const RegionsFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>Customer Region</label>
    <Select
      isMulti
      value={filters.regions}
      options={filterOptions.regions}
      onChange={options => changeFilters({ ...filters, regions: isBlank(options) ? 'All' : options })}
    />
  </div>
)

const ViewFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>View</label>
    <Select
      value={find(filterOptions.currentViews, ['value', filters.currentView])}
      options={filterOptions.currentViews}
      onChange={option => {
        const groupByField = option.value === 'applications' ? 'Customer' : 'Cluster'

        changeFilters({ ...filters, currentView: option.value, groupByField })
      }}
    />
  </div>
)

const LocationFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>Location</label>
    <Select
      isMulti
      value={filters.locations}
      options={filterOptions.locations}
      onChange={options => changeFilters({ ...filters, locations: isBlank(options) ? 'All' : options })}
    />
  </div>
)

const CustomerFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>Customer</label>
    <Select
      isMulti
      value={filters.customers}
      options={filterOptions.customers}
      onChange={options => changeFilters({ ...filters, customers: isBlank(options) ? 'All' : options })}
    />
  </div>
)
const FunctionFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className = "col" >
    <label>Function</label>
    <Select
      isMulti
      value={filters.functions}
      options={filterOptions.functions}
      onChange={options => changeFilters({ ...filters, functions: isBlank(options) ? 'All' : options })}
    />
  </div>
)

const OwnershipFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>Ownership</label>
    <Select
      isMulti
      value={filters.ownerships}
      options={filterOptions.ownerships}
      onChange={options => changeFilters({ ...filters, ownerships: isBlank(options) ? 'All' : options })}
    />
  </div>
)

const OperatingSystemFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>Operating System</label>
    <Select
      isMulti
      value={filters.operating_systems}
      options={filterOptions.operating_systems}
      onChange={options => changeFilters({ ...filters, operating_systems: isBlank(options) ? 'All' : options })}
    />
  </div>
)

const ApplicationsFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>Applications</label>
    <Select
      isMulti
      value={filters.licensableSoftware}
      options={filterOptions.licensableSoftware}
      onChange={options => changeFilters({ ...filters, licensableSoftware: isBlank(options) ? 'All' : options })}
    />
  </div>
)

const ApplicationGroupFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>Application Group</label>
    <Select
      isMulti
      value={filters.licensableSoftwareGroups}
      options={filterOptions.licensableSoftwareGroups}
      onChange={options => changeFilters({ ...filters, licensableSoftwareGroups: isBlank(options) ? 'All' : options })}
    />
  </div>
)

const VendorFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>Vendor</label>
    <Select
      isMulti
      value={filters.vendors}
      options={filterOptions.vendors}
      onChange={options => changeFilters({ ...filters, vendors: isBlank(options) ? 'All' : options })}
    />
  </div>
)

const EditionFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>Edition</label>
    <Select
      isMulti
      value={filters.editions}
      options={filterOptions.editions}
      onChange={options => changeFilters({ ...filters, editions: isBlank(options) ? 'All' : options })}
    />
  </div>
)

const OSDataSourceFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>OS Data Source</label>
    <Select
      isMulti
      value={filters.machine_type_sources}
      options={filterOptions.machine_type_sources}
      onChange={options => changeFilters({ ...filters, machine_type_sources: isBlank(options) ? 'All' : options })}
    />
  </div>
)

const PowerFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>Power</label>
    <Select
      value={find(filterOptions.powerState, ['value', filters.powerState])}
      options={filterOptions.powerState}
      onChange={option => changeFilters({ ...filters, powerState: option.value })}
    />
  </div>
)

const GroupByFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>Group by:</label>
    <Select
      value={find(filterOptions.groupByFields, ['value', filters.groupByField])}
      options={filterOptions.groupByFields}
      onChange={option => changeFilters({ ...filters, groupByField: option.value })}
    />
  </div>
)

const ResourceFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>Resource</label>
    <Select
      isMulti
      value={filters.resources}
      options={filterOptions.resources}
      onChange={options => changeFilters({ ...filters, resources: isBlank(options) ? 'All' : options })}
    />
  </div>
)

const ApplicationEditionFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>Edition</label>
    <Select
      isMulti
      value={filters.applicationEditions}
      options={filterOptions.applicationEditions}
      onChange={options => changeFilters({ ...filters, applicationEditions: isBlank(options) ? 'All' : options })}
    />
  </div>
)

const PlatformTypeFilter = ({ filterOptions, filters, changeFilters }) => (
  <div className="col">
    <label>Platform Type</label>
    <Select
      isMulti
      value={filters.platformTypes}
      options={filterOptions.platformTypes}
      onChange={options => changeFilters({ ...filters, platformTypes: isBlank(options) ? 'All' : options })}
    />
  </div>
)


const ClusterFilters = ({ filters, filterOptions, changeFilters }) => (
  <Fragment>
    <GroupByFilter {...{ filterOptions, filters, changeFilters }} />
    <LocationFilter {...{ filterOptions, filters, changeFilters }} />
    <CustomerFilter {...{ filterOptions, filters, changeFilters }} />
    <FunctionFilter {...{ filterOptions, filters, changeFilters }} />
    <OwnershipFilter {...{ filterOptions, filters, changeFilters }} />
    <EditionFilter {...{ filterOptions, filters, changeFilters }} />
    <OSDataSourceFilter {...{ filterOptions, filters, changeFilters }} />
    <PowerFilter {...{ filterOptions, filters, changeFilters }} />
  </Fragment>
)

const CustomerFilters = ({ filters, filterOptions, changeFilters }) => (
  <Fragment>
    <GroupByFilter {...{ filterOptions, filters, changeFilters }} />
    <RegionsFilter {...{ filterOptions, filters, changeFilters }} />
    <LocationFilter {...{ filterOptions, filters, changeFilters }} />
    <CustomerFilter {...{ filterOptions, filters, changeFilters }} />
    <EditionFilter {...{ filterOptions, filters, changeFilters }} />
    <OSDataSourceFilter {...{ filterOptions, filters, changeFilters }} />
    <PowerFilter {...{ filterOptions, filters, changeFilters }} />
  </Fragment>
)

const OperatingSystemFilters = ({ filters, filterOptions, changeFilters, children }) => {
  merge(filterOptions, {
    currentViews: [{ value: 'operating_systems', label: 'Operating Systems' }, { value: 'applications', label: 'Applications' }, ],
    powerState: [{ value: 'All', label: 'All' }, { value: 'On', label: 'On' }, { value: 'Off', label: 'Off' }],
    groupByFields: [{ value: 'Cluster', label: 'Cluster' }, { value: 'Customer', label: 'Customer' }, { value: 'OperatingSystem', label: 'Operating System' }],
    resources: [{ value: 'Managed Service', label: 'Managed Service' }, { value: 'CloudCore', label: 'CloudCore' }]
  })

  return (
    <div className="row mb-3">
      {children}

      {filters.groupByField === 'Cluster' && (
        <ClusterFilters {...{ filters, filterOptions, changeFilters }} />
      )}

      {filters.groupByField != 'Cluster' && (
        <Fragment>
          <CustomerFilters {...{ filters, filterOptions, changeFilters }} />
          <ResourceFilter {...{ filterOptions, filters, changeFilters }} />
        </Fragment>
      )}

      {filters.groupByField === 'none' && (
        <OperatingSystemFilter {...{ filterOptions, filters, changeFilters }} />
      )}
    </div>
  )
}

const ApplicationFilters = ({ filters, filterOptions, changeFilters, children, needsGroupBy = true, className = '' }) => {
  merge(filterOptions, {
    currentViews: [{ value: 'operating_systems', label: 'Operating Systems' }, { value: 'applications', label: 'Applications' },],
    powerState: [{ value: 'All', label: 'All' }, { value: 'On', label: 'On' }, { value: 'Off', label: 'Off' }],
    groupByFields: [{ value: 'Customer', label: 'Customer' }, { value: 'Application', label: 'Application' }],
    resources: [{ value: 'Managed Service', label: 'Managed Service' }, { value: 'CloudCore', label: 'CloudCore' }]
  })

  return (
    <div className={`row mb-3 ${className}`}>
      {children}
      {needsGroupBy && <GroupByFilter {...{ filterOptions, filters, changeFilters }} />}
      <CustomerFilter {...{ filterOptions, filters, changeFilters }} />
      <RegionsFilter {...{ filterOptions, filters, changeFilters }} />
      <ResourceFilter {...{ filterOptions, filters, changeFilters }} />
      <ApplicationsFilter {...{ filterOptions, filters, changeFilters }} />
      {/* <ApplicationGroupFilter {...{ filterOptions, filters, changeFilters }} /> */}
      <ApplicationEditionFilter {...{ filterOptions, filters, changeFilters }} />
      <PlatformTypeFilter {...{ filterOptions, filters, changeFilters }} />
    </div>
  )
}

export {
  ApplicationFilters,
  OperatingSystemFilters,
  defaultFilters,
  defaultApplicationFilters,
  defaultOperatingSystemFilters
}
